import React from 'react';
import PropTypes from 'prop-types';

import Pic1 from '../../InstallImages/Inverters/SMA';


const Inverter = ({ terms }) => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <p className="specsText">As a system technology specialist, SMA has been developing and distributing high-quality PV inverters and innovative technology for intelligent energy management for over 30 years. Our technology and service solutions for all photovoltaic applications offer users more efficiency and independence in meeting their energy needs.
            </p>
            { terms.resiToggle === true ?
                <div>
                    <p className="specsText">With SMA inverters, communication solutions and our comprehensive range of services, you can be sure that your PV system will produce as much solar power as possible.
                    </p>
                    <p className="specsText">The benefit to you: Producing your own energy enables you to be more independent from increasing electricity prices. In states that offer net metering, surplus electricity generated by your solar system feeds back into the grid and you receive a credit which can result in thousands of dollars saved yearly.
                    </p>
                    <p className="specsText">In addition, with our innovative communication solutions you can monitor your PV system around the clock, control your electricity consumption and compare notes with other PV system owners.
                    </p>
                </div>
                :
                <div>
                    <p className="specsText">
                        Next-generation commercial PV systems are much more than a way to offset energy costs. They are true energy solutions, revolutionizing the way businesses participate in energy markets. From generation to load usage, commercial solutions from SMA allow plant owners an unmatched level of monitoring and control including the ability to participate in the energy trading market of the future, opening untapped revenue streams.
                    </p>
                    <h1>The SunSpec Alliance</h1>
                    <p className="specsText">
                        The SunSpec Alliance is a wellrespected trade group whose mission is to accelerate the growth of the distributed energy industry and expand the market for renewable power. More than 100 leading organizations are SunSpec Alliance participants and are investing in growing industry standardization. To date, the SunSpec Alliance has successfully introduced dozens of information and communication standards that have been adopted industry-wide.
                    </p>
                    <p className="specsText">
                        The SunSpec Alliance recently introduced a method to achieve NEC 2017 module-level shutdown compliance through the use of power line communications (PLC). Titled the SunSpec Communication Signal for Rapid Shutdown Interoperability Specification, this open standard is designed to lower integration costs and deliver a variety of interoperable products to PV professionals. More than 30 companies actively contributed to the development of this particular standard, including SMA.
                    </p>
                </div>
            }
        </div>
    </div>
);

Inverter.propTypes = {
    terms: PropTypes.object.isRequired,
};

export default Inverter;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Inverters/sma.js